/**
 * email-body-html — Conversion texte brut -> HTML de paragraphes (cote client).
 *
 * Parite STRICTE avec `supabase/functions/_shared/email-layout.ts`
 * (`bodyTextToHtml` / `BODY_TEXT_COLOR`). On ne peut pas importer le fichier
 * Deno depuis le bundle navigateur (imports https://… ailleurs dans le module),
 * d'ou ce miroir. A garder synchronise.
 *
 * Bug #2 (texte clair illisible) : on force une couleur foncee explicite par
 * paragraphe pour qu'en dark-mode le corps ne soit pas repeint clair (le texte
 * sans couleur explicite herite et se fait inverser, contrairement a la
 * signature qui porte des couleurs inline -> corps illisible sur fond blanc).
 */

/** Couleur de texte du corps (navy tres fonce). Identique au serveur. */
export const BODY_TEXT_COLOR = "#1a1a2e";

function escapeHtml(text: string): string {
  return text
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

/** Convertit le texte brut d'un mail en paragraphes HTML couleur foncee. */
export function bodyTextToHtml(text: string): string {
  return text
    .split(/\n{2,}/)
    .map((para) => para.trim())
    .filter((para) => para.length > 0)
    .map(
      (para) =>
        `<p style="margin:0 0 16px;color:${BODY_TEXT_COLOR};line-height:1.7;">${escapeHtml(para).replace(/\n/g, "<br>")}</p>`,
    )
    .join("\n");
}
